import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment'
import BColor from '../BColor'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.background.default,
        // },
    },
}))(TableRow);

function createData(ymd, bias5, status5, bias20, status20) {
    return { ymd, bias5, status5, bias20, status20 };
}


const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 250,
      backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
    },
    button1: {
      minWidth: 110,
    }
  }));

export default function BIASList(props) {
    const classes = useStyles();
    const [buyselldata, setBuyselldata] = React.useState([]);

    useEffect(() => {
        if(props.open) fectchStockData(props.stockId)
    }, [props.stockId]);


    function fectchStockData(stockId) {
        if(stockId != null) {
            let a = {
                sid: stockId
            };

            fetch("/jstock/v1/stock/bias", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        let dd = result.bias.map(row =>
                            createData(moment(row.ymd, "YYYYMMDD").format('YYYY/MM/DD'), row.bias5, row.status5, row.bias20, row.status20)
                        )
                        setBuyselldata(dd)
                    },
                    error => {
                    }
                );
        }
    }

    function getColor(value) {
        if(value >= 0) return "#f7456c"
        else return "#7bbd4f"
    }

    function renderbias(value, status) {
        let k = <Button size="small" variant="outlined" style={{ color: BColor.nodatacolor }} className={classes.button1} >
            -
            </Button>

        if (status === 2 && value != -99999.0) {
            k = <Button size="small" style={{ background: BColor.upcolorbox, color: '#FFFFFF' }} className={classes.button1}>
                    過熱 {value}%
            </Button>
        } else if (status === 1 && value != -99999.0) {
            k = <Button size="small" variant="outlined" style={{ color: BColor.upcolorbox }} className={classes.button1}>
                    正常　{value}%
            </Button>
        } else if (status === 0 && value != -99999.0) {
            k = <Button size="small" variant="outlined" style={{ color: BColor.faircolor }} className={classes.button1} >
                    正常　{value}%
            </Button>
        } else if (status === 3 && value != -99999.0) {
            k = <Button size="small" variant="outlined" style={{ color: BColor.downcolorbox }} className={classes.button1} >
                    正常　{value}%
            </Button>
        } else if (status === 4 && value != -99999.0) {
            k = <Button size="small" style={{ background: BColor.downcolorbox, color: '#FFFFFF' }} className={classes.button1} >
                    跌深 {value}%
            </Button>
        } 

        return <StyledTableCell align="right"  align="right">
                {k}
        </StyledTableCell>

    }

    return (
        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">乖離率表</DialogTitle>

            <DialogContent>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>日期</StyledTableCell>
                                <StyledTableCell align="center">5日乖離率</StyledTableCell>
                                <StyledTableCell align="center">20日乖離率</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.ymd}
                                    </StyledTableCell>
                                    {renderbias(row.bias5, row.status5)}
                                    {renderbias(row.bias20, row.status20)}
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}
